import { Button } from '@mui/material';
import { UploadFileInputProps } from './UploadFileInput.types';

export const UploadFileInput = ({
  fileInputRef,
  selectedFile,
  disabled,
  onFileSelected,
  onPickClick,
  accept = '.xlsx,.xls'
}: UploadFileInputProps) => {
  const inputText = selectedFile ? selectedFile.name : 'Файл не вибрано';
  return (
    <div className="upload-file-container">
      <div className={`upload-file-wrapper ${disabled ? 'disabled' : ''}`}>
        <input
          ref={fileInputRef}
          type="file"
          className="upload-file-input"
          disabled={disabled}
          accept={accept}
          onChange={onFileSelected}
        />
        <Button className="upload-file-button" disabled={disabled} onClick={onPickClick}>
          Вибір файлу
        </Button>
        <span className={`upload-file-name ${selectedFile ? 'selected' : 'placeholder'}`}>{inputText}</span>
      </div>
    </div>
  );
};
